import { Typography } from '@mui/material';
import axios from 'axios'
import React, { useEffect, useState } from 'react';
import Card from "../components/Card";
import { model, fblink } from '../config/config';
import { TablePagination } from "@mui/material";
var fbkey = Math.random() * 90;
var currentpage = 0;
var firstlast = "limitToFirst";
var atvalue = "startAt";


function Series() {
  const [page, setPage] = useState(0);
  const [content, setContent] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(20);

  const fetchMovies = async () => {
    const { data } = await axios.get(`${fblink}/watchface/${model}.json?orderBy="install"&${atvalue}=${fbkey}&${firstlast}=20`)

    let arrayOfObjects = Object.keys(data).map(key => {
		let ar = data[key]
		ar.key = key
		return ar})
		
        setContent(arrayOfObjects);
		 window.scroll(0, 0);
		localStorage.setItem("attempts", "0")
  }
  useEffect(() => {
    fetchMovies();
  }, [page])
  
  const handleChangePage = (event, newPage) => {
		    if(currentpage < newPage){
				firstlast = "limitToFirst";
				atvalue = "startAt"
				currentpage = newPage;
				fbkey = Math.random() * 90;
			}
			else
			{
				firstlast = "limitToLast";
				atvalue = "endAt"
				currentpage = newPage;
				fbkey = Math.random() * 90;
			}
		
		setPage(newPage);
		window.scroll(0, 0);
	  };

	  const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 20));
		setPage(0);
	  };
	  
  return (
    <div className='container' style={{ padding: "64px 1vw 64px 1vw" }}>
      <Typography variant="h4" component="div" mb={4}>
        Amazfit {model.toUpperCase()} random watch faces
      </Typography>
     
      <div className="card-grid">
        {
          content && content.map(item => {
            return <Card key={item.fileid} {...item} binfile="tv"/>
          })

        }
      </div>
	  <TablePagination
			  component="div"
			  count={500}
			  page={page}
			  onPageChange={handleChangePage}
			  rowsPerPage={20}
			  rowsPerPageOptions={[20]}
			  onRowsPerPageChange={handleChangeRowsPerPage}
			/>
      
    </div>
  )
}

export default Series